import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';
import { VesselsService } from 'src/app/services/vessels.service';
@Component({
  selector: 'app-penalty-points-sidebar',
  templateUrl: './penalty-points-sidebar.component.html',
  styleUrls: ['./penalty-points-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PenaltyPointsSidebarComponent implements OnInit {
  searchText: string = '';
  penaltyForm: UntypedFormGroup;
  penaltyFormvalue:any;
  isError:boolean = false;
  // ispointError:boolean = false;
  // isscrubberError:boolean = false;
  // errorMessage:string = '';
  @Output() getPenaltyform = new EventEmitter<any>();
  @Output() getPenaltydate = new EventEmitter<any>();
  @Output() getPenaltyreason = new EventEmitter<any>();
  @Output() getPenaltyEndDate = new EventEmitter<any>();
  @Output() calculatedPenaltyVal = new EventEmitter<any>();
  @Output() getRemovePenaltyReason = new EventEmitter<any>();
  @Input() currentpoolPoint:any;
  @Input() endPenlatypercent:any;
  @Input() showaddPenalty:any;
  @Input() calculatedPoolPoints:any;
  @Input() removePenaltyDate:any;
  @Input() removePenaltyTime:any;
  @Input() shipName:string;
  @Input() shipPool:string;
  @Input() isUsedinCalculation:boolean;
  @Input() dateToDisplayInModal:any;
  @Input() vesselActivationDate:any;
  
  private readonly decimalPattern = /^(?:[1-9]\d?)(?:\.\d{1,2})?$/;

  showScrubber: boolean = false;
  effectivePoolpts:any;
  penaltyVal: any;
  penaltyDateselected: any;
  penaltyEndDateselected:any;
  penaltyReason: string = '';
  public subscription: Subscription;
  removePenaltyReason: string = '';
  getFYdate: any;
  disableFYdate: any;
  currentYear: number;
  showPenaltyErrorMsg: boolean = false;
  newEffectivePoolPoints: number;

  private readonly penaltyRequiredMessage = 'Penalty value is required.';
  private readonly penaltyPatternMessage = 'Please enter a valid decimal input.';

  constructor( private fb: UntypedFormBuilder, private vesselService:VesselsService) {
  }

  ngOnInit() {

  //  document.body.classList.add('addEndPenaltyDatePicker')
    this.penaltyForm = this.fb.group({
      penalty: ['', [Validators.required,Validators.pattern(this.decimalPattern)]],
      // date:['', [Validators.required]],
      // penaltyReason:['', [Validators.required]],
    });
    
    this.penaltyForm.valueChanges.pipe(debounceTime(1000),distinctUntilChanged()).subscribe((value:any) => {
      console.log(value)
      this.penaltyVal = value?.penalty;
      console.log(this.penaltyVal)
      this.effectivePoolpts = parseFloat(this.currentpoolPoint);
      if(this.penaltyForm.valid){
        const penaltyValue = parseFloat(this.penaltyVal) || 0;
        // (original PP - 100 X percerntage) == (10 * 34 ) / 100
        // this.effectivePoolpts = this.effectivePoolpts - (100 * (penaltyValue / 100));
        this.effectivePoolpts = (penaltyValue * this.effectivePoolpts ) / 100;
        // this.effectivePoolpts = this.effectivePoolpts - penaltyValue;
        // this.effectivePoolpts = Math.round(this.effectivePoolpts * 100) / 100;
        console.log(this.effectivePoolpts)
        this.calculatedPenaltyVal.emit(this.effectivePoolpts)
        this.getPenaltyform.emit(this.penaltyForm)
        console.log(this.currentpoolPoint)
        this.newEffectivePoolPoints =  (this.currentpoolPoint - this.effectivePoolpts);
      }
    });
  
    this.subscription = this.vesselService.cancelPenalty.subscribe((res:any)=>{
      if(res){
        this.penaltyDateselected = '';
        this.penaltyReason = '';
        this.effectivePoolpts = this.currentpoolPoint;
        this.penaltyForm.patchValue({
          penalty: '' 
        });
      }
    })
    console.log("showaddPenalty",this.showaddPenalty)
    console.log(this.endPenlatypercent)
    this.getFYdate = sessionStorage.getItem('fiscalYearStartDate');
    const date  = new Date(this.getFYdate);
    let newDate = new Date(date.setDate(date.getDate() - 1));
    this.disableFYdate = new Date(newDate.toISOString().slice(0, 10));
    console.log(this.disableFYdate)
    this.currentYear = new Date().getFullYear();
    console.log(this.dateToDisplayInModal)
    console.log(this.vesselActivationDate)
    this.vesselActivationDate = new Date(this.vesselActivationDate)
    // if(vesselActivationDate >= this.disableFYdate){
    //   this.disableFYdate = vesselActivationDate;
    // }

  }
  get minSelectableDate(): Date {
    return this.vesselActivationDate > this.disableFYdate
      ? this.vesselActivationDate
      : this.disableFYdate;
  }
  getMonthShort(month: number): string {
    return new Date(0, month - 1).toLocaleString('en', { month: 'short' });
  }
  onTimeChange(event) {
  }
  selectedDate(event: any) {
    console.log(event)
    this.penaltyDateselected = event;
    this.getPenaltydate.emit(this.penaltyDateselected)
  }
  selectedendPenlatyDate(event: any){
    console.log(event)
    this.penaltyEndDateselected = event;
    this.getPenaltyEndDate.emit(this.penaltyEndDateselected)
  }
  fieldValue(e:any){
    this.penaltyReason = e;
    console.log(e);
    if(this.penaltyReason.length >= 500){
      this.isError = true
    }else{
      this.isError = false
    }
    this.getPenaltyreason.emit(this.penaltyReason)
    
  }
  removePenaltyFieldVal(e:any){
    this.removePenaltyReason = e;
    this.getRemovePenaltyReason.emit(this.removePenaltyReason)
    console.log(e);
  }
  handleFocusOutPenalty(e:any){
    this.showPenaltyErrorMsg = true;
  }

  isPenaltyInputError(): boolean {
    return !!this.getPenaltyInputErrorMessage();
  }

  getPenaltyInputErrorMessage(): string {
    const control = this.penaltyForm?.get('penalty');
    if (!control?.invalid) {
      return '';
    }

    if (control.hasError('pattern') && control.dirty) {
      return this.penaltyPatternMessage;
    }

    if (control.hasError('required') && (control.dirty || (this.showPenaltyErrorMsg && control.touched))) {
      return this.penaltyRequiredMessage;
    }

    return '';
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    // document.body.classList.remove('addEndPenaltyDatePicker')
  }
}